import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import server from "../../api/server";
import { createPortal } from "react-dom";

const CeoShow = ({ match }) => {
	const {
		params: { bannerID },
	} = match;
	const myRef = useRef();
	const metaTypeList = [
		{ name: "الرئيسية", value: "home" },
		{ name: "اتصل بنا", value: "contact" },
		{ name: "من نحن", value: "about" },
		{ name: "الخدمات", value: "services" },
		{ name: "المدونه", value: "blogs" },
		{ name: "الاعمال", value: "ourWorks" },
		{ name: "الاسعار", value: "prices" },
	];
	const auth = useSelector(state => state.auth.user);
	const [meta, setMeta] = useState([]);

	const [addedMeta, setAddedMeta] = useState({
		name: "",
		content: "",
		type: "",
	});
	const [editedMeta, setEditedMeta] = useState({
		name: "",
		content: "",
		type: "",
	});
	const [disableEditedMetaInputs, setDisableEditedMetaInputs] = useState(true);

	const [loading, setLoading] = useState("");

	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "تعديل روابط السيو",
				breadcrumb: "السيو",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		try {
			setLoading(true);
			const response = await server().get("/metadataTags");
			const { metadata_tags: metaDataTags } = response?.data?.data || {};
			setMeta(metaDataTags);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	const focusEditMetaInput = () => {
		myRef.current.focus();
		myRef.current.scrollIntoView();
	};

	const handleDeleteMetaClick = async id => {
		try {
			setLoading(true);
			await server().delete(`/metadataTags/${id}`);
			toast.success("تم بنجاح!");
			setLoading(false);
			setEditedMeta();

			onStart();
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة مره اخرى!");
			setLoading(false);
		}
	};

	const handleInputChange = e => {
		const { name, value } = e?.target || {};
		setAddedMeta({
			...addedMeta,
			[name]: value,
		});
	};
	const handleEditMetaInputChange = e => {
		const { name, value } = e?.target || {};
		setEditedMeta({
			...editedMeta,
			[name]: value,
		});
	};

	const handleAddMetaClick = async e => {
		e.preventDefault();

		const arrayOfMetaNames = meta.map(singleMeta => singleMeta?.name);
		const arrayOfMetaTypes = meta.map(singleMeta => singleMeta?.type);

		// Check if the name is unique
		if (arrayOfMetaNames.includes(addedMeta?.name)) {
			return toast.error("لايمكنك اضافه نفس العنوان مرتين");
		}

		// Check if the type is unique
		if (arrayOfMetaTypes.includes(addedMeta?.type)) {
			return toast.error("لا يمكنك إضافة نفس نوع الميتا مرتين");
		}
		if (arrayOfMetaNames.includes(addedMeta?.name))
			return toast.error("لايمكنك اضافه نفس العنوان مرتين");

		try {
			setLoading(true);
			await server().post(`/metadataTags`, { ...addedMeta });
			toast.success("تم بنجاح!");
			setLoading(false);
			setAddedMeta({
				name: "",
				content: "",
				type: "",
			});
			onStart();
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة مره اخرى!");
			setLoading(false);
		}
	};

	const handleSaveEditMetaClick = async () => {
		const { id } = editedMeta || {};
		console.log("passed", id);
		try {
			setLoading(true);
			await server().put(`/metadataTags/${id}`, editedMeta);
			toast.success("تم بنجاح!");
			setLoading(false);
			onStart();
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة مره اخرى!");
			setLoading(false);
		}
	};

	const handleEditMetaClick = async (e, item) => {
		e.preventDefault();
		setEditedMeta(item);
		setDisableEditedMetaInputs(false);
		focusEditMetaInput();
	};

	return (
		<>
			{/*Editing modal */}
			{createPortal(
				<div
					className="modal fade"
					id="editMetaModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="editMetaModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="editMetaModalLabel">
									تعديل رابط
								</h5>
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label="Close"
								>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body" ref={myRef}>
								<div className="form-item">
									<label htmlFor="name">عنوان الميتا</label>
									<input
										type="text"
										id="name"
										name="name"
										value={editedMeta?.name}
										onChange={handleEditMetaInputChange}
										disabled={disableEditedMetaInputs}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="content">وصف الميتا</label>
									<input
										type="text"
										id="content"
										name="content"
										value={editedMeta?.content}
										onChange={handleEditMetaInputChange}
										disabled={disableEditedMetaInputs}
									/>
								</div>
							</div>
							<div className="modal-footer">
								<button
									type="button"
									className="btn btn-secondary"
									data-dismiss="modal"
								>
									اغلاق
								</button>
								<button
									type="button"
									className="bt bt-success"
									onClick={handleSaveEditMetaClick}
									data-dismiss="modal"
								>
									حفظ التعديل
								</button>
							</div>
						</div>
					</div>
				</div>,
				document.body
			)}

			<section>
				{loading && <Loader />}
				<form onSubmit={() => true}>
					<div className="row">
						<div className="col-md-12">
							<div className="card">
								<div className="card-header">
									<h3 className="h3 ">اضافه رابط</h3>
								</div>
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="name">عنوان الميتا</label>
										<input
											type="text"
											id="name"
											name="name"
											value={addedMeta?.name}
											onChange={handleInputChange}
										/>
									</div>
									<div className="form-item">
										<label htmlFor="content">وصف الميتا</label>
										<input
											type="text"
											id="content"
											name="content"
											value={addedMeta?.content}
											onChange={handleInputChange}
										/>
									</div>
									<div className="form-item">
										<label htmlFor="type">نوع الميتا</label>
										<select
											name="type"
											id="type"
											value={addedMeta?.type}
											onChange={handleInputChange}
										>
											<option key={8888888} value={""}>
												{"اختر نوع الميتا"}
											</option>
											{metaTypeList?.map((item, index) => (
												<>
													<option key={item.name} value={item.value}>
														{item.name}
													</option>
												</>
											))}
										</select>
									</div>

									<div className="form-item mt-3 col-sm-3">
										<button
											type="button"
											onClick={handleAddMetaClick}
											className="bt bt-success btn-block"
										>
											اضافه
										</button>
									</div>
								</div>
							</div>
						</div>

						<h3 className="h3 mt-5">الروابط المضافه</h3>
						{meta?.map(item => (
							<div className="col-md-12 my-2">
								<div className="card">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="name">عنوان الميتا</label>
											<input
												type="text"
												id="name"
												name="name"
												value={item?.name}
												readOnly
											/>
										</div>
										<div className="form-item">
											<label htmlFor="content">وصف الميتا</label>
											<input
												type="text"
												id="content"
												name="content"
												value={item?.content}
												readOnly
											/>
										</div>
										<div className="form-item">
											<label htmlFor="type">نوع الميتا</label>
											<input
												type="text"
												id="type"
												name="type"
												value={
													metaTypeList.find(x => x.value === item?.type)?.name
												}
												readOnly
											/>
										</div>
										<div className="row">
											<div className="form-item mt-3 col-sm-6">
												<button
													type="button"
													onClick={e => handleEditMetaClick(e, item)}
													className="bt bt-success btn-block"
													data-toggle="modal"
													data-target="#editMetaModal"
												>
													تعديل
												</button>
											</div>
											<div className="form-item mt-3 col-sm-6">
												<button
													type="button"
													onClick={() => handleDeleteMetaClick(item?.id)}
													className="bt bt-danger btn-block"
												>
													حذف
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</form>
			</section>
		</>
	);
};

export default CeoShow;
